import { useGlobalSearchParams, usePathname } from 'expo-router';

import { getLegacyRedirectPathname } from 'navigation/routing/legacy-redirects';

// strip these expo-router internal params to avoid issues on redirects
const INTERNAL_PARAMS = ['initial', 'path', 'pop', 'state', 'not-found'];

export const useMaybeGetLegacyRedirect = (stripParams: string[] = []) => {
  const pathname = usePathname();
  const params = useGlobalSearchParams();

  let query = '';
  if (Object.keys(params).length > 0) {
    const urlParams = new URLSearchParams(params as Record<string, string>);
    INTERNAL_PARAMS.concat(stripParams).forEach(p => {
      urlParams.delete(p);
    });
    query = urlParams.toString();
  }

  const redirect = getLegacyRedirectPathname(pathname);
  if (redirect) {
    let redirectBuilder = redirect;

    if (query) {
      redirectBuilder += `?${query}`;
    }

    if (__DEV__) {
      // eslint-disable-next-line no-console
      console.log('Legacy redirect', {
        from: pathname + (query ? `?${query}` : ''),
        to: redirectBuilder,
      });
    }
    return redirectBuilder;
  }
  return null;
};
